import {
  call, put, select, spawn, takeLatest
} from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";

import {
  projectsSortColumnsSet, projectsSortStart, projectsSortSuccess, uiSetIsSorting
} from "Store/Actions";
import { selectProjectList, selectSortedColumns } from "Store/Selectors/Projects";
import { sortItems } from "Workers/Sort";
import { hasElements } from "Utils/Array";
import { toIdList } from "Utils/Project";
import { IProject } from "Model/Storage/IProject";
import { Translator } from "Utils/Translator";

function* projectsSortStartSaga({ payload }: PayloadAction<[string, boolean][]>) {
  yield put(projectsSortColumnsSet(payload));
  const projectList: IProject[] = yield select(selectProjectList);

  const sortedItems = yield call(sortItems, projectList, payload, Translator.getInstance().getActiveLocale());

  yield put(projectsSortSuccess(toIdList(sortedItems)));
}

export function* projectsSortInitSaga() {
  const columns: [string, boolean][] = yield select(selectSortedColumns);

  if (!hasElements(columns)) {
    return;
  }
  yield put(uiSetIsSorting(true));
  yield spawn(projectsSortStartSaga, projectsSortStart(columns));
}

export function* SortSaga(): Generator<unknown, void> {
  yield takeLatest(projectsSortStart, projectsSortStartSaga);
}
